import { Card } from "@amzn/stencil-react-components/card";
import { InputHeader } from "@amzn/stencil-react-components/input";
import { Col } from "@amzn/stencil-react-components/layout";
import { Span, TextVariant } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { PickupPhone } from "@/pages/Replacement/replacement.types";
import { CHOOSE_DELIVERY_STRINGS } from "../choose-delivery.constants";
import { PhoneNumberFields } from "./phone-number-fields";

const FIELD_PREFIX = "pickupPhone";
const TITLE_ID = `${FIELD_PREFIX}-title`;
const GROUP_ID = `${FIELD_PREFIX}-group`;

export interface PickupPhonePanelProps {
  phone: PickupPhone;
  phoneCodes: string[];
  onChange: (phone: PickupPhone) => void;
}

export const PickupPhonePanel: FC<PickupPhonePanelProps> = ({ phone, phoneCodes, onChange }) => (
  <Card width="100%" data-testid="pickup-phone-panel">
    <Col id={GROUP_ID} role="group" aria-labelledby={TITLE_ID} gridGap="S200" width="100%">
      <InputHeader
        labelText={getString(`${CHOOSE_DELIVERY_STRINGS}.pickupPhoneTitle`)}
        labelId={TITLE_ID}
        htmlFor={GROUP_ID}
        required
        renderLabel={({ children, color, labelId }) => (
          <Span id={labelId} color={color} variant={TextVariant.LabelMD}>
            {children}
          </Span>
        )}
      />
      <PhoneNumberFields
        phoneCodes={phoneCodes}
        countryCode={{
          testId: `${FIELD_PREFIX}-countryCode`,
          value: phone.phoneCountryCode,
          onChange: (phoneCountryCode) => onChange({ ...phone, phoneCountryCode }),
        }}
        phoneNumber={{
          testId: `${FIELD_PREFIX}-phoneNumber`,
          value: phone.phoneNumber,
          onChange: (phoneNumber) => onChange({ ...phone, phoneNumber }),
        }}
      />
    </Col>
  </Card>
);
